import React, { Component } from "react";
import ButtonLoader from "../../components/common/buttonLoader/ButtonLoader";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { CommonValidationMessages } from "../../utils/Messages";
import { TextInput } from "../../components/allTypesInputComponents/AllTypeInputComponents";
import { checkParameters, decryptionAPI } from "../../utils/Encryption";
import ValidationText from "../../utils/validation/ValidationText";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import SlotMemberService from "../../services/axiosServices/apiServices/SlotMemberService";
import { Navigate, Route, Routes } from "react-router-dom";
import { getAuditContext } from "../../utils/audit/AuthenticationLibrary";
export default class AuditCertificatesUpload extends Component {
  constructor(props) {
    super(props);

    this.financeService = new FinanceServices();
    this.SLOTSMemberServices = new SlotMemberService();
    this.swalServices = new SwalServices();
    this.state = {
      isLoading: false,
      bookingId: 0,
      sLOTSSchedulersLogDetails: {
        slotsSchedulerLogId: 0,
        slotsMemberId: 0,
        membershipPaymentTypeId: 0,
        isMailSend: false,
        companyName: '',
        firstName: "",
        lastName: "",
        membershipType: "",
        mobileNumber: "",
        email: "",
        schedulerName: "",

      },
      fileNameList: [],
      message: "",
      paymentProofDetails: {
        corporateMemberId: 0,
        filePath: "",
        comments: "",
        fileDisplayName: "",
      },
      submitPaymentProof: false,
      slotsMemberId: 0,
      validationRule: {
        comments: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "comments for payment"
            ),
          },
        ],
        fileDisplayName: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "payment proof"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      uploadFileCount: 0,
      auditFileupload: false,
      auditCertificatesUpload: 0,

    };
  }

  // componentDidMount = () => {

  //   const params = window.location.href.split("=");
  //   let SLOTSMemberId_ = params[1] || "";
  //   let SLOTSMemberId = Number((SLOTSMemberId_));
  //   this.GetSLOTSSchedulersLogById(SLOTSMemberId);
  // };

  componentDidMount = () => {
    const audit = getAuditContext()

    const params = new URLSearchParams(window.location.search);

    // Check for View Only
    const checkRead = window.location.search;
    const getRead = checkRead.split("=");
    const checkFinal = getRead[3];

    const memberTypeId = getRead[1];
    const slotMemberId = checkParameters(memberTypeId);
    this.setState({ isslotMemberId: slotMemberId });
    const slotId = params.get("slotId");
    if (slotId && checkParameters(slotId, "Number")) {
      this.setState({ slotMemberId: slotId }, () => {
        this.GetSLOTSSchedulersLogById(slotId);
      });
    } else {
      this.GetSLOTSSchedulersLogById(slotMemberId);
    }
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  };


  GetSLOTSSchedulersLogById = (slotMemberId) => {

    this.financeService.GetSLOTSSchedulersLogById(slotMemberId).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({
          sLOTSSchedulersLogDetails: response.responseItem.responseContent,
        });
      } else {
        this.SwalServices.Error(response.message);
      }
    });
  };

  handleChange(event, identity) {
    const value = event.target.value;
    const name = event.target.name;

    let detail = { ...this.state.paymentProofDetails };
    detail[name] = value;

    this.setState({ paymentProofDetails: detail });
  }

  uploadSLOTSBatchjobFiles = () => {
    const audit = getAuditContext()

    const { sLOTSSchedulersLogDetails, paymentProofDetails } = this.state;
    const filespath = this.state.fileNameList || [];

    // Validate that at least one document is uploaded
    if (
      filespath.length === 0 || filespath.some(path => !path || !path.trim())
    ) {
      this.swalServices.ErrorWithAction("Please upload at least one document.", "OK");
      return;
    }


    let filespathString = filespath.join(',');
    
    if (sLOTSSchedulersLogDetails.slotsMemberId > 0) {
      const request = {
        slotsMemberId: sLOTSSchedulersLogDetails.slotsMemberId,
        filePath: filespathString,
        comments: paymentProofDetails.comments,
        slotsSchedulerLogId: sLOTSSchedulersLogDetails.slotsSchedulerLogId,
        createdBy: audit.adminUserId,
        createdAppId: audit.appId,

      };
      // if (this.validateField()) {
      this.setState({ auditFileupload: true }, () => {
        this.SLOTSMemberServices.uploadSLOTSBatchjobFiles(request)
          .then((response) => {
            if (
              response.statusCode === 200 &&
              response.responseItem != null &&
              response.responseItem.responseContent != null
            ) {
              this.swalServices.SuccessWithAction("Your Documents submitted successfully.", "OK")
                .then(() => {
                  this.setState({ auditFileupload: false });
                  window.location.href = "/financial/AuditCertificateAttendanceUpload";
                });
            } else {
              this.setState({ auditFileupload: false });
              this.swalServices.Error(response.message);
            }
          });
      });
      //}
    } else {
      this.swalServices.ErrorWithAction("Please check your information.", "OK").then(() => {

      });
    }
  };

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.paymentProofDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  onFileChange = (event, fileType) => {
    
    if (this.state.sLOTSSchedulersLogDetails.slotsMemberId > 0) {
      var schedulerName = this.state.sLOTSSchedulersLogDetails.schedulerName;
      let filespath = this.state.fileNameList;
      let uploadFileCount = filespath.length;
 
      const file = event.target.files[0];
      if (file) {
        if (file.size < 5242880) {
          if (fileType === "upload_File") {
            if (uploadFileCount < 10) {
              if (file && file.type === "application/pdf" || file.type === "application/pdf" ||
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel" || file.type === "application/vnd.ms-excel") {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.auditCertificatesUpload + 1}`;
                if (schedulerName === "Audit Reminder (18th Month)") {
                  uploadFile.storagePath = "SLOTSMemberPDFs\\SLOTSAuditDocuments";
                }
                else {
                  uploadFile.storagePath = "SLOTSMemberPDFs\\SLOTSAttendaceCertificate";
                }
                //uploadFile.storagePath = "SLOTSMemberPDFs\\AuditCertificateDocuments";
                //this.setState({ isFileLoader: true });
                this.SLOTSMemberServices.uploadPDF(uploadFile).then((response) => {

                  if (response != null) {
                    if (response.isNotCurrupted == true) {
                      let detail = { ...this.state.sLOTSSchedulersLogDetails };
                      let filePaths = []
                      //  let detail2 = { ...this.state.SLOTSApplicationSummary };
                      // detail.uploadWPOnlineRecord = response.fileName;
                      detail["upload_File"] = response.fileName;
                      //  detail2["uploadWPOnlineRecord"] = response.fileName;
                      //filePaths.push(response.fileName);
                      this.state.fileNameList.push(response.fileName)
                      this.setState({ sLOTSSchedulersLogDetails: detail },
                        () => {
                          this.saveSLOTsDocuments('upload_File');
                        });

                      //this.setAllFieldsCalculation();
                    }
                    else {
                      this.swalServices.Error("Document is invalid");
                    }
                  }
                  else {
                    this.swalServices.Error(response.message);
                  }
                  //  this.setState({ isFileLoader: false });
                })
              }
              else {
                this.swalServices.Error("Please upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !");
              }
            }
            else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
        }
        else {
          this.swalServices.Error("File size must be less than 5 MB!");
        }
      }
    } else {
      this.swalServices.ErrorWithAction("Please login for upload documents!", "OK").then((res) => {
        // location.reload();
      });
    }
    //}
  };

  saveSLOTsDocuments = (fileType, validationFieldName, SelectName) => {

    if (this.state.slotsMemberId > 0) {

      let request = {};
      request.columnName = fileType;
      request.slotsMemberId = this.state.slotsMemberId;
      request.fileName = '';

      if (fileType === 'upload_File') {
        if (this.state.sLOTSSchedulersLogDetails.fileListRecord.length > 0) {
          request.fileName = '';
          let arr1 = this.state.sLOTSSchedulersLogDetails.fileListRecord.map(function (value) {
            return value;
          });
          request.fileName = arr1.join([","]);
        }

        this.SLOTSMemberServices.saveSLOTsDocuments(request).then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            if (this.state.fileDeletedFlag === true) {
              this.swalServices.Success("File Deleted");
              this.setState({ fileDeletedFlag: false });
            } else {
              this.swalServices.Success("File Uploaded");
            }

            if (validationFieldName, SelectName) {
              this.validateField(validationFieldName, SelectName);
            }
          } else {
            this.swalServices.Error(response.message);
          }

        });
      }
    }
  };

  render() {
    return (
      <div className='container mx-auto payment-confirm'>
        <div className=" md:mt-10">
          {/* <div className="big-text-title">
            <h2 className="theme-color">
              Payment Confirmation
            </h2>
          </div> */}
          {/* <h2 className="theme-color form-info-title-txt md:mt-10 mt-5 md:mb-0 mb-5">
            Membership Payment
          </h2> */}
          <div className="md:my-14">
            <div className="custom-card workshop-shadow">
              <div className="bg-[#fafafa] mb-10">
                <div className="2xl:px-6 2xl:py-10 lg:px-5 lg:py-5 px-5 py-5">
                  <div className="grid grid-cols-12 gap-6 w-full ">
                    <div className="col-span-12 items-center">
                      <div className="grid grid-cols-12 gap-6">
                        <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                          <div className="flex items-baseline justify-between">
                            <div className="left-side w-[50%] flex">
                              <h2 className="text-xl font-bold theme-color 2xl:mb-3">
                                {this.state.sLOTSSchedulersLogDetails.companyName}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="mt-2 border-t border-t-[#c9c9c9]"></hr>
                  <div className="grid grid-cols-12 gap-6 w-full ">
                    <div className="col-span-12 2xl:pt-7 lg:mt-4 mt-4 items-center">
                      <div className="grid grid-cols-12 gap-6">
                        <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                          <div className="grid grid-cols-12 lg:gap-6 gap-0">
                            <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                              <div className="flex items-center lg:justify-start justify-between">
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  Representative Name:
                                </h2>
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  {this.state.sLOTSSchedulersLogDetails.firstName} {this.state.sLOTSSchedulersLogDetails.lastName}
                                </h2>
                              </div>
                              <div className="flex items-center lg:justify-start justify-between">
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  Representative Contact Number:
                                </h2>
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  {this.state.sLOTSSchedulersLogDetails.mobileNumber}
                                </h2>
                              </div>


                              <div className="flex items-center lg:justify-start justify-between">
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  Membership Type:
                                </h2>
                                <div className="text-xl lg:w-[50%] w-auto">
                                  <h2
                                    className="text-xl text-[#757575]"

                                  >
                                    {this.state.sLOTSSchedulersLogDetails.membershipType}
                                  </h2>
                                </div>
                              </div>
                            </div>
                            <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                              <div className="flex md:items-center md:flex-row flex-col lg:justify-start md:justify-between justify-start">
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  Representative Email Address:
                                </h2>
                                <h2 className="text-xl lg:w-[50%] w-auto">
                                  {this.state.sLOTSSchedulersLogDetails.email}
                                </h2>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h1 className="text-[28px] mobile-18 font-bold lg:pb-7 lg:pt-10 mt-4 border-t border-[#c9c9c9]">
            Audit and Certificate Documents
          </h1>
          {/* <p className="text-[18px]  mobile-14 lg:my-10 mt-2">
            Please upload proof of payment via PNG, JPEG or PDF file (Max size Less
            then 2MB) We will take 3 working days to process your payment
            confirmation. Upon successful confirmation, you will receive an
            email to confirm your payment.
          </p> */}
          <div className="bottom-form">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h1 className="text-[20px] mt-10 font-bold ">
                  {this.state.sLOTSSchedulersLogDetails.schedulerName}
                </h1>
              </div>
              <div className="col-span-12 md:mb-14 mb-5">
                <div className="grid grid-cols-12 lg:gap-6 gap-2 items-center mb-5">
                  <div className="2xl:col-span-2 lg:col-span-2 md:col-span-2 col-span-12">
                    <label className="input-title mb-3">
                      Upload File
                    </label>
                  </div>
                  <div className="2xl:col-span-7 lg:col-span-7 md:col-span-7 col-span-8">
                    <input
                      className="w-full custom-input"
                      type="text"
                      name=""
                      value={this.state.fileNameList}
                      disabled={true}
                    />
                  </div>
                  <div className="2xl:col-span-2 lg:col-span-3 md:col-span-3 col-span-4">
                    <div className="flex items-center justify-center">
                      <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border">
                        <label
                          htmlFor={`upload_File`}
                          className="text-uplod block text-sm theme-color w-full"
                        >
                          Select File
                        </label>

                        <input
                          className="sr-only"
                          id={`upload_File`}
                          type="file"
                          //onChange={(event) => this.onFileChange(event,"auditCertificateFile")}
                          onChange={(event) =>
                            this.onFileChange(
                              event,
                              "upload_File"
                            )
                          }
                        />
                      </form>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-12 lg:gap-6 gap-2 items-center mb-10">
                  <div className="2xl:col-span-2 lg:col-span-2 md:col-span-2 col-span-12">
                  </div>
                  <div className="2xl:col-span-7 lg:col-span-7 md:col-span-7 col-span-8">
                    <table class="min-w-full border border-gray-300 text-left">
                      <thead class="bg-gray-200">
                        <tr>
                          <th class="border border-gray-300 px-4 py-2">File Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.fileNameList.length === 0 ? (
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 text-gray-500">No files selected</td>
                          </tr>
                        ) : (
                          this.state.fileNameList.map((fileName, index) => (
                            <tr key={index}>
                              <td className="border border-gray-300 px-4 py-2">{fileName}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="2xl:col-span-2 lg:col-span-3 md:col-span-3 col-span-4">
                  </div>
                </div>
                <div className="grid grid-cols-12 md:gap-6 gap-2 lg:items-center">
                  <div className="2xl:col-span-2 lg:col-span-2 md:col-span-2 col-span-12">
                    <label className="input-title mb-3">
                      Comments
                      <span className="theme-color">*</span>
                    </label>
                  </div>
                  <div className="2xl:col-span-7 lg:col-span-7 md:col-span-7 col-span-12">
                    <textarea
                      className="w-full"
                      id=""
                      rows="4"
                      name="comments"
                      value={this.state.paymentProofDetails.comments}
                      onChange={(e) => this.handleChange(e)}
                      onBlur={() => this.validateField("comments")}
                    />
                    <div>
                      <ValidationText
                        error={this.state.validState.error.comments}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 items-center">
                  <div className="2xl:col-span-2 lg:col-span-2 md:col-span-2 md:block hidden"></div>
                  <div className="2xl:col-span-7 lg:col-span-7 md:col-span-7 col-span-12">
                    <div className="flex items-center justify-center">
                      <button
                        className="btn btn-blue mt-10 text-white inner-title-font-small-button font-bold"
                        onClick={() => this.uploadSLOTSBatchjobFiles()}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
